import script from "./DeveloperCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DeveloperCard.vue?vue&type=script&setup=true&lang=js"

import "./DeveloperCard.vue?vue&type=style&index=0&id=af405952&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af405952"]])

export default __exports__